<template>
  <div>
    <v-col cols="12" class="text-center">
      <h3 class="mb-4">{{ mensajeConfirmacion }}</h3>
      <div class="d-flex justify-center gap-2">
        <TextButton color="error" class="mr-1" @click="cancelar">Cancelar</TextButton>
        <TextButton color="secondary" @click="confirmar">Confirmar</TextButton>
      </div>
    </v-col>
  </div>
</template>

<script>
import TextButton from '@/components/base/TextButton.vue'
import { mapActions } from 'vuex'

export default {
  name: 'ConfirmacionVincularPersonalConvocatoria',

  components: { TextButton },

  props: {
    item: {
      type: Object,
      required: true,
    },
    tipoActualizacion: {
      type: String,
      required: true,
      validator: (value) => ['aceptado', 'promocionado'].includes(value),
    },
    nuevoValor: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    mensajeConfirmacion() {
      if (this.tipoActualizacion === 'aceptado') {
        const accion = this.nuevoValor ? 'Aceptada' : 'NO Aceptada'
        return `¿Está seguro de que desea marcar como ${accion} esta convocatoria para ${this.item.nombreCompleto}?`
      } else {
        const accion = this.nuevoValor ? 'Promocionado' : 'NO Promocionado'
        return `¿Está seguro de que desea marcar como ${accion} para esta convocatoria a ${this.item.nombreCompleto}?`
      }
    },
  },

  methods: {
    ...mapActions('convocatorias', ['updatePersonalConvocatoria']),

    async confirmar() {
      if (!this.item?.id_personal) {
        console.error('Falta id_personal en el item:', this.item)
        this.$store.commit('SET_SNACKBAR_MESSAGE', 'Error: Falta ID del personal')
        this.$emit('close')
        return
      }

      if (!this.item?.idConvocatoriaPersonal) {
        console.error('Falta idConvocatoriaPersonal en el item:', this.item)
        this.$store.commit('SET_SNACKBAR_MESSAGE', 'Error: Falta ID de la convocatoria del personal')
        this.$emit('close')
        return
      }

      try {
        const payload = {
          idConvocatoriaPersonal: this.item.idConvocatoriaPersonal,
          aceptado: this.tipoActualizacion === 'aceptado' ? this.nuevoValor : this.item.aceptado ?? false,
          promocionado: this.tipoActualizacion === 'promocionado' ? this.nuevoValor : this.item.promocionado ?? false,
        }

        await this.updatePersonalConvocatoria({
          idPersonal: this.item.id_personal,
          idConvocatoriaPersonal: this.item.idConvocatoriaPersonal,
          payload,
        })

        const mensaje =
          this.tipoActualizacion === 'aceptado'
            ? 'Estado de aceptación actualizado correctamente'
            : 'Estado de promoción actualizado correctamente'

        this.$store.commit('SET_SNACKBAR_MESSAGE', mensaje)
        this.$emit('confirmed', {
          idPersonal: this.item.id_personal,
          idConvocatoriaPersonal: this.item.idConvocatoriaPersonal,
          aceptado: payload.aceptado,
          promocionado: payload.promocionado,
        })
        this.$emit('close')
      } catch (error) {
        console.error('Error al actualizar:', error)
        const mensaje =
          this.tipoActualizacion === 'aceptado'
            ? 'Error al actualizar el estado de aceptación'
            : 'Error al actualizar el estado de promoción'

        this.$store.commit('SET_SNACKBAR_MESSAGE', mensaje)
        this.$emit('error')
        this.$emit('close')
      }
    },

    cancelar() {
      this.$emit('cancelled')
      this.$emit('close')
    },
  },
}
</script>
